import { motion } from "framer-motion"

export function IntegrationSection() {
  return (
    <section id="integration" className="py-24 bg-black text-white overflow-hidden relative">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-600/20 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-16">
          <div className="flex-1">
            <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                Everything connects. <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
                  That's the magic.
                </span>
              </h2>
              <p className="text-xl text-gray-400 mb-8 leading-relaxed">
                Z isn't just a collection of apps. It's a unified ecosystem where data flows freely. Find a restaurant,
                share it on the map, invite friends from your community, and book a ride—all in one flow.
              </p>

              <div className="space-y-6">
                {[
                  "Find restaurant → Share on map → Post to communities",
                  "See job → Check commute on map → Apply instantly",
                  "Watch video → Buy featured product → Track delivery",
                ].map((flow, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-4 p-4 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-400 font-bold text-sm">
                      {i + 1}
                    </div>
                    <span className="font-medium">{flow}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-md aspect-square">
              {/* Central Hub */}
              <motion.div
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center z-20 shadow-2xl shadow-blue-500/50"
                animate={{ scale: [1, 1.05, 1] }}
                transition={{ duration: 4, repeat: Infinity }}
              >
                <span className="text-4xl font-bold">Z</span>
              </motion.div>

              {/* Orbiting Icons */}
              {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, i) => (
                <motion.div
                  key={i}
                  className="absolute top-1/2 left-1/2 w-12 h-12 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl flex items-center justify-center"
                  style={{
                    x: -24,
                    y: -24,
                  }}
                  animate={{
                    rotate: 360,
                    translateX: `${Math.cos((deg * Math.PI) / 180) * 140}px`,
                    translateY: `${Math.sin((deg * Math.PI) / 180) * 140}px`,
                  }}
                  transition={{
                    rotate: { duration: 20, repeat: Infinity, ease: "linear" },
                    translateX: { duration: 0.1 },
                  }}
                >
                  <div className="w-2 h-2 bg-white rounded-full" />
                </motion.div>
              ))}

              {/* Orbit Rings */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[280px] h-[280px] border border-white/10 rounded-full" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[380px] h-[380px] border border-white/5 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
